export enum SliderBannerStatus {
  Active = 1,
  Pending = 2,
  Expired = 3,
  Rejected = 4,
  Terminated = 5,
}
